import { render } from "./IconArrow.vue?vue&type=template&id=38c22cdd"
const script = {}

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__